<template>
  <div class="white_bg">
    <div
        class="filter_config_container"
        :style="{
          height: is_show ? '210px': '85px',
        }"
      >
        <template v-for="item in filterConditionRef" :key="item.field">
          <div class="config_item">
            <div class="config_label">{{ item.field }} :</div>
            <div class="config_list flex flex_wrap">
              <span
                :class="[
                  !filterSelectedData[item.field].selectedText ? 'current' : '',
                ]"
                @click="changeFilterSelectedData(item.field, config, '')"
                style="padding: 0 10px"
                >不限</span
              >
              <span
                :class="[
                  filterSelectedData[item.field].selectedText == config.text
                    ? 'current'
                    : '',
                ]"
                v-for="config of item.list"
                :key="config.text"
                @click="
                  changeFilterSelectedData(item.field, config, config.text)
                "
                >{{ config.text }}</span
              >
            </div>
          </div>
        </template>
      </div>
      <div class="show_or_hide" @click="is_show = !is_show">
        <div class="show_or_hide_btn">
          <div>
            {{ is_show ? "点击收起" : "展开更多" }}
          </div>
          <div
            class="icon_sanjiao"
            :class="is_show ? 'zhankai' : 'shouqi'"
          ></div>
        </div>
      </div>
    <div class="filter_result_container">
      <el-table
        empty-text="暂无数据,敬请期待。"
        :data="carData"
        :cell-class-name="'center'"
        :header-row-class-name="'center table_header'"
        
      >
        <el-table-column
          v-for="attr of thRef"
          :label="attr.name"
          :prop="attr.type"
          :key="attr.type"
        >
          <template #default="scope">
            <template v-if="attr.type == 'model_img' && scope.row[attr.type]">
              <img class="model_img" :src="scope.row[attr.type]" alt="" />
            </template>
            <span v-else :class="attr.class">
              {{ scope.row[attr.type] || "-" }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="">
          <template #default="scope">
            <div class="changeModelBtn" @click="changeModel(scope.row)">
              选择车型
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        hide-on-single-page
        layout="prev, pager, next"
        :total="count"
        :page-size="pageSize"
        v-model:currentPage="currentPage"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from "vue";
import { 
getCarFilterConfig, 
getCarLibrary, 
  // changeUserCar 
} from "@/api";
import { ElTable, ElTableColumn, ElPagination, ElLoading } from "element-plus";
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
// import 'swiper/css/swiper.css'
// import 'swiper/dist/css/swiper.css'
//   , useRouter
import { useRoute, useRouter } from "vue-router";
import store from "@/store";
export default {
  name: "ChangeModel",
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
  },
  setup() {
    const route = useRoute(),
      router = useRouter();
    console.log(route.query);
    let {
      not_in_id,
      // report_id,
      model_id: old_model_id = "",
      is_ceping = 0,
    } = route.query;
    //筛选项
    const filterConditionRef = ref([]);
    // 筛选项选中的数据
    const filterSelectedData = reactive({});
    //tab签th
    const thRef = ref([
      {
        type: "model_img",
        name: "",
      },
      {
        type: "brand",
        name: "品牌",
      },
      {
        type: "model_name",
        name: "车型",
      },
      {
        type: "energy_type_str",
        name: "能源",
      },
      {
        type: "price",
        name: "指导价",
      },
      {
        type: "total_score",
        name: "综合得分",
        class: "orange",
      },
      {
        type: "top",
        name: "综合排名",
        class: "orange",
      },
    ]);
    const getCarFilterConfigData = () => {
      getCarFilterConfig().then((res) => {
        if (res.code == 200) {
          const { condition } = res.data;
          filterConditionRef.value = condition;
          for (let item of condition) {
            filterSelectedData[item.field] = {
              selectedText: "",
              params: {},
            };
          }
        }
      });
    };
    // 点击筛选项
    const changeFilterSelectedData = (type, data, selectedText) => {
      if (filterSelectedData[type].selectedText == selectedText) {
        return;
      }
      filterSelectedData[type].selectedText = selectedText;
      if (data) {
        filterSelectedData[type].params = data.params;
      } else {
        filterSelectedData[type].params = {};
      }
      currentPage.value = 1;
      count.value = 0;
      getCarData();
    };
    const count = ref(0),
      currentPage = ref(1),
      pageSize = ref(20),
      carData = ref([]);

    // 获取车型列表数据
    const getCarData = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const data = {
        page: currentPage.value,
        rows: pageSize.value,
      };
      if (not_in_id) {
        data.not_in_id = not_in_id;
      }
      //重新请求list
      let params = {};
      for (let key in filterSelectedData) {
        Object.assign(params, filterSelectedData[key].params);
      }
      getCarLibrary({
        ...data,
        ...params,
      }).then((res) => {
        if (res.code == 1) {
          count.value = res.data.count;
          const list = res.data.list;
          console.log(list);
          if (data.first_id && list[0] && list[0].id == data.first_id) {
            list[0].isWarning = true;
          }
          carData.value = list;
        }
        loading && loading.close();
      });
    };
    getCarFilterConfigData();
    getCarData();

    // const initGetData = async () => {
    //   await getCarFilterConfigData()
    //   getCarData()
    // }
    // initGetData()
    // 点击页数时
    const handlePageChange = () => {
      getCarData();
    };
    // 返回传参问题
    const changeModel = (row) => {
      // let model_id = row.model_id;
      // const  data  = {
      //     model_id
      // }
      // if(report_id){
      //       data.report_id = report_id
      // }
      // if(old_model_id){
      //   data.old_model_id = old_model_id
      // }
      // sessionStorage.setItem('changeCarId', JSON.stringify(data))
      // console.log(router.options.history.state.back)
      let prev_url = router.options.history.state.back;
      let prev_link = prev_url.split("?")[0];
      let params = GetUrlParam(prev_url);
      // let query_data = {}
 
      if (prev_link.indexOf("/report/index")>-1) {

        router.push({
          path:"/report/index",
          query:{
            model_img:row.model_img,
            model_name:row.short_name||row.model_name,
            model_id:row.id,
            report_id:row.report_id,
          }
        })
     
      } else if (prev_link == "/contrast/multi_analyse/index") {
        console.log("12345",row.short_name,row.model_name,row);
        if (old_model_id) {
          store.updateCompareCarData2(old_model_id, {
            model_id: row.id,
            model_img: row.model_img,
            model_name: row.short_name||row.model_name,
            report_id: row.report_id,
          });
          router.go(-1);
        } else {
          store.setCompareCarData2({
            model_id: row.id,
            model_img: row.model_img,
            model_name: row.short_name||row.model_name,
            report_id: row.report_id,
          });
          router.go(-1);
        }
      } else if (prev_link == "/contrast/evaluation") {
        if (is_ceping) {
          //有old_model_id是更换车型,没有是添加车型
          if (old_model_id) {
            store.updateCompareCarData2(old_model_id, {
              model_id: row.id,
              model_img: row.model_img,
              model_name: row.short_name||row.model_name,
              report_id: row.report_id,
            });
            router.go(-1);
          } else {
            store.setCompareCarData2({
              model_id: row.id,
              model_img: row.model_img,
              model_name: row.short_name||row.model_name,
              report_id: row.report_id,
            });
            router.go(-1);
          }
        } else {
          let model_ids = JSON.parse(decodeURIComponent(params.model_ids));
          if (old_model_id) {
            model_ids = model_ids.map((item) => {
              if (item == old_model_id) {
                return row.id;
              } else {
                return item;
              }
            });
            router.replace({
              path: prev_link,
              query: {
                ...params,
                model_name:decodeURIComponent(params.short_name || params.model_name),
                model_ids: JSON.stringify(model_ids),
              },
            });
          } else {
            model_ids.push(row.id);
            router.replace({
              path: prev_link,
              query: {
                ...params,
                model_name:decodeURIComponent(params.short_name || params.model_name),
                model_ids: JSON.stringify(model_ids),
              },
            });
          }
        }
      } else if (prev_link.indexOf("/contrast/analyse")>-1) {
        router.replace({
          path: prev_link,
          query: {
            model_img:row.model_img,
            model_name: row.short_name||row.model_name,
            model_id: row.id,
            report_id:row.report_id
          },
        });
      }
    };
    const is_show = ref(false);
    return {
      filterConditionRef,
      filterSelectedData,
      thRef,
      count,
      currentPage,
      pageSize,
      carData,
      changeFilterSelectedData,
      handlePageChange,
      changeModel,
      is_show,
    };
  },
};
function GetUrlParam(url) {
  let arrObj = url.split("?");
  let params = Object.create(null);
  if (arrObj.length > 1) {
    arrObj = arrObj[1].split("&");
    arrObj.forEach((item) => {
      item = item.split("=");
      params[item[0]] = item[1];
    });
  }
  return params;
}
</script>

<style scoped lang="less">
.white_bg {
  width: 1200px;
  padding: 26px 53px 63px;
}
.filter_config_container {
  width: 1090px;
  font-size: 14px;
  color: #474747;
  height: auto;
  transition: height 500ms;
  position: relative;
  overflow: hidden;
  .config_item {
    line-height: 32px;
  }
  .config_label {
    float: left;
    margin: 5px 0;
    color: #474747;
    font-weight: bold;
  }
  .config_list {
    margin-left: 62px;
    span {
      margin: 8px;
      display: inline-block;
      height: 26px;
      line-height: 26px;
      padding: 0 3px;
      white-space: nowrap;
      cursor: pointer;

      &:first-child {
        margin-left: 0;
      }
      &:hover {
        background: #ebefff;
        color: #474747;
      }
      &.current {
        background: #1fbcbf;
        color: #fff;
      }
    }
  }
}
.filter_result_container {
  width: 1090px;
  margin-top: 39.999984px;
}
.changeModelBtn {
  cursor: pointer;
  color: #1FBCBF;
}
:deep(.el-tabs__header) {
  margin-bottom: 0;
}
:deep(.el-tabs__nav-wrap::after) {
  display: none;
}
:deep(.el-tabs__item) {
  height: 45px;
  font-size: 15px;
  // &.is-active, &:hover{
  //   font-weight: bold;
  //   color: #00CDFF;
  // }
}
:deep(.el-tabs__active-bar) {
  height: 3px;
  // background: #00CDFF;
  border-radius: 0.999984px;
}
:deep(.center .cell) {
  text-align: center;
  color: #474747;
}
:deep(.table_header th) {
  background: #ebefff;
  font-weight: bold;
}
// .#F5F8FF{
//   background: #F5F8FF;
// }
:deep(.el-pagination) {
  margin-top: 39.999984px;
  text-align: center;
  .btn-prev,
  .btn-next {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}
.show_or_hide {
  width: 1200px;
  height: 29px;
  margin-left: -53px;
  border-radius: 0 0 20px 20px;
  border-bottom: solid 1px #dee8f6;
  background: #fff;
  position: relative;
  .show_or_hide_btn {
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    color: #969696;
    background: #fff;
    .icon_sanjiao {
      width: 10px;
      height: 10px;
      margin-left: 7px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/common/zksq_sanjiao.png)
        no-repeat center center;
      background-size: 8px;
      transition: all 500ms;
      &.shouqi {
        transform: rotateZ(180deg);
      }
    }
  }
}
.model_img {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.orange {
  font-size: 14px;
  font-weight: bold;
  color: #e7816e;
  line-height: 19px;
}
</style>